import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fonts.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { verifyAnalyticsEnv } from './utils/envTests';

const container = document.getElementById('root');
const root = createRoot(container);

if (process.env.NODE_ENV !== 'production') {
  const envValid = verifyAnalyticsEnv();
  if (!envValid) {
    console.warn('Analytics environment variables are not properly configured!');
  } else {
    console.log('Analytics environment variables verified successfully.');
  }
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);